import { ObjectTypeEnum } from "../enums/object-types";
import { Location } from "./locations";
import { DateTime } from "luxon";

export class Service {
  id!: string;
  objectType!: ObjectTypeEnum;
  action!: string;
  size!: string;
  weight!: number;
  tenantId!: string;
  locationName!: string;
  locationId!: Location;
  createdAt!: DateTime;
  customData: string | null | undefined;
}
